// Reversible removal: keep bookings and financial records attached to their business.
export const isBusinessTrashed = (business) => business?.adminTrash?.active === true;

export function businessTrashPatch(business, actor, now = new Date().toISOString()) {
  if (isBusinessTrashed(business)) return {};
  const previous = {};
  for (const key of ['status', 'approvalStatus', 'approved', 'isApproved', 'isActive', 'visible', 'hidden', 'published']) {
    previous[key] = business[key] ?? null;
  }
  return {
    adminTrash: { active: true, at: now, by: actor, previous },
    status: 'deleted', approvalStatus: 'deleted', approved: false, isApproved: false,
    isActive: false, visible: false, hidden: true, published: false,
  };
}

export function businessRestorePatch(business, actor, now = new Date().toISOString()) {
  if (!isBusinessTrashed(business)) return {};
  return {
    ...(business.adminTrash.previous || {}),
    // Restoration never republishes a business without a separate admin decision.
    isActive: false, visible: false, hidden: true, published: false,
    adminTrash: { ...business.adminTrash, active: false, restoredAt: now, restoredBy: actor },
  };
}

export function isCalendarBusinessTrashed(entry = {}) {
  return [entry, entry.business, entry.raw, entry.raw?.business].some(b => b && (isBusinessTrashed(b) || b.status === "deleted" || b.approvalStatus === "deleted"));
}
